define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const _ = require('underscore');
    const tmpl = require('tmpl');
    const device = require('util/device.util');
    const AutocompleteWidget = require('widgets/autocomplete.widget');
    const parentFunc = {
        reCalcContainerStyles: AutocompleteWidget.prototype.reCalcContainerStyles
    };

    require('common/jbone.widget');
    require('widgets/autocomplete.widget');

    const isNumeric = function(n) {
        return _.isNumber(n) && _.isFinite(n) && !_.isNaN(n);
    };

    module.exports = $.widget('autocomplete', 'autocomplete', {

        createContainer: function() {
            this.$container = $('<ul>')
                .addClass(this.id.slice(1))
                .addClass('autocomplete-list')
                .addClass(this.options.className);

            const appendTo = this.el.closest('.fn-lookup');

            $(appendTo).append(this.$container);
        },

        subscribeToWindowEvents: function() {
            if (this.model.get('isSubscribedToWindowEvents')) {
                return;
            }

            $(window).on('tap' + this.id, this.onWindowTap.bind(this));
            $(window).on('keydown' + this.id, this.onWindowKeyDown.bind(this));
            $(window).on('resize' + this.id, _.debounce(parentFunc.reCalcContainerStyles, 150));

            this.model.set('isSubscribedToWindowEvents', true);
        },

        reCalcContainerStyles: function() {
            if (this.model.get('isHidden')) {
                return;
            }

            const { formFactor, os } = device;
            const field = this.$container[0].parentElement;
            const clientRect = field.getBoundingClientRect();
            const isErrorTooltip = field.querySelector('.error-tooltip');
            const inputHeight = field.querySelector('.field__control').getBoundingClientRect().height;
            const isInPopup = this.$container[0].closest('.fn-popups');
            const currentPosition = this.$container.css('position');
            const showNationality = this.options.isCustomElement && os !== 'android';
            const isAboveShowing = formFactor === 'mobile' && os === 'ios' || showNationality;
            const positionElement = clientRect.top + clientRect.height / 2;
            const deviceHeight = window.innerHeight;
            const middleOfHeight = deviceHeight / 2;
            const moveTop = isErrorTooltip ? inputHeight : clientRect.height;
            if (isAboveShowing && middleOfHeight < positionElement) {
                this.$container.css({
                    width: clientRect.width + 'px',
                    top: 'auto',
                    bottom: '100%'
                });
                !this.$container.hasClass('aboveDropDown') && this.$container.addClass('aboveDropDown');
                this.model.set('isOpenAbove', true);
            } else {
                this.$container.css({
                    width: clientRect.width + 'px',
                    top: moveTop + 'px',
                    left: '0',
                    bottom: 'inherit',
                    position: isInPopup ? 'fixed' : currentPosition
                });
                this.$container.hasClass('aboveDropDown') && this.$container.removeClass('aboveDropDown');
                this.model.set('isOpenAbove', false);
            }
        },

        search: function(input) {
            const setResult = this.setResult.bind(this);
            const searchFn = this.options.search;
            let result = [];

            if (searchFn && input && input.length >= this.options.minLength) {
                result = searchFn(input);
            }
            // is promise
            if (window.Promise.resolve(result) === result) {
                result.then(setResult, setResult);
            } else {
                this.options.isCustomElement && !input ? this.options.showAll() : setResult(result);
            }
        },

        renderAutocomplete: function(items) {
            this.$container.html($(tmpl[this.options.template](items)));
            const insideContainer = $(this.el.closest('.field-control__lookup')?.querySelector('#autocomplete-container')) ||
                $(this.el.closest('[data-custom-control="customNationality"]')?.querySelector('#autocomplete-container')) ||
                $(this.el.closest('[data-custom-control="customEmail"]')?.querySelector('#autocomplete-container'));
            this.model.get('isOpenAbove') ? insideContainer.append(this.$container) : $(this.options.appendTo).append(this.$container);
            this.setMaxHeight();
        },

        setMaxHeight: function() {
            const isAbove = this.model.get('isOpenAbove');
            const isMobile = device.formFactor === 'mobile';
            const isTablet = device.formFactor === 'tablet';
            const regForm = $('.form_name_registration');
            const isRegForm = regForm && regForm.length > 0;
            const item = this.$container.find('.fn-autocomplete-item')[0];
            const fiveVisibleRows = parseInt(this.options.visibleRows);
            const fourVisibleRows = parseInt(this.options.visibleRows) - 1;

            if (item && isNumeric(fiveVisibleRows) && fiveVisibleRows > 0) {
                let maxHeight;
                const height = parseFloat(getComputedStyle(item).height);

                if (isRegForm && (isMobile || isTablet) && isAbove && !this.options.isCustomElement) {
                    maxHeight = height * fourVisibleRows - fourVisibleRows + 'px';
                } else {
                    maxHeight = height * fiveVisibleRows + 'px';
                }

                this.$container.css('max-height', maxHeight);
            }
        },

        onWindowTap: function(event) {
            if (this.el === event.target) {
                return;
            }

            if (!this.options.collapseOnSelect && $(event.target).hasClass('fn-autocomplete-item')) {
                return;
            }

            // If not custom nationality field then focusout
            !this.el.classList.contains('fn-nationality-input-text') && this.focusOut();
        },

        onTextFocusout: function(event) {
            const onSelect = this.options.onSelect;
            if (this.$container.find('.hover').length && this.options.isCustomElement) {
                const index = this.findActiveItemIndex(this.$container.find('.hover')[0]);
                index && onSelect && onSelect(index);
            } else if (this.options.isCustomElement && !event.target.value) {
                this.model.set({ searchResult: [] });
                onSelect && onSelect(null);
            }

            this.model.set({ isFocused: false });
        }
    });

});
